import styled from '@emotion/styled'
import { V2L2SmallModalRoot } from '../V2L2ModalRoot'
import { V2L2ModalTitlebar, V2L1ModalDismissButton } from '../V2ModalTitlebar'
import { V2L2ModalContent, V2L2ModalDetail } from '../V2ModalContent'
import { V2L2ModalActionbar } from '../V2L2ModalActionbar'
import { V2L1ReasonableButton } from '../../Button/V2L1ReasonableButton'

const Select = styled.select({
	width: '100%',
	// this isn't exactly the design, but we don't want to stray away from
	// using the standard iOS component here, so we'll just get close
	fontSize: `${20/16}rem`,
})

interface V2L3CancelEncounterModalProps {
	encounterType: 'Appointment'|'Encounter'
	reasons: string[]
	selectedReason?: string
	onChange?: React.ChangeEventHandler<HTMLSelectElement>
	onSubmitClick?: React.MouseEventHandler<HTMLButtonElement>
	onDismissClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const V2L3CancelEncounterModal = ({encounterType, reasons, selectedReason, onChange, onSubmitClick, onDismissClick}: V2L3CancelEncounterModalProps) => {
	return (
		<V2L2SmallModalRoot>
			<V2L2ModalTitlebar
				title={`Cancel ${encounterType}`}
				buttons={<V2L1ModalDismissButton onClick={onDismissClick} />}
			/>
			<V2L2ModalContent>
				<V2L2ModalDetail title="Reason">
					<Select 
						value={selectedReason}
						onChange={onChange}
					>
						<option></option>
						{reasons.map((reason, idx) => (
							<option key={idx} value={reason}>
								{reason}
							</option>
						))}
					</Select>
				</V2L2ModalDetail>
			</V2L2ModalContent>
			<V2L2ModalActionbar>
				<V2L1ReasonableButton
					label="Confirm Cancellation"
					onClick={onSubmitClick}
				/>
			</V2L2ModalActionbar>
		</V2L2SmallModalRoot>
	)
}
